import { invokeAmTpDemoAiTask } from './invokeAmTpDemoAiTask';
import { TAmDemoAiContextFor } from './types';

/** Returns the node list and the intake form the canvas renders. */
export async function assembleAmTpDemoWorkflow(
  context: TAmDemoAiContextFor<'workflow.assemble'>
) {
  return invokeAmTpDemoAiTask('workflow.assemble', context);
}
